import { Fragment, useState, useCallback, useEffect } from "react"
import {useTranslation} from 'react-i18next';

import HtmlInput from './HtmlInput';

import Hide from '../../assets/icons/hide.png';
import View from '../../assets/icons/view.png';

const PasswordComponent = ({setFormErrors, setFormValues}) => {
    const {t: translate } = useTranslation();
    const passFields = {
        password: '',
        repeatPassword: '',
    };

    const passChecksFields = [
        {
            title: translate('eight-characters'),
            pattern: /^.{8,}$/,
            passfail: false
        },
        {
            title: translate('one-number'),
            pattern: /[0-9]/,
            passfail: false
        },
        {
            title: translate('one-uppercase'),
            pattern: /[A-Z]/,
            passfail: false
        },
        {
            title: translate('one-lowercase'),
            pattern: /[a-z]/,
            passfail: false
        },
        // {
        //     title: 'At least one special character',
        //     pattern: /(?=.*?[#?!@$%^&*-])/,
        //     passfail: false
        // },
        {
            title: translate('no-whitespaces'),
            //eslint-disable-next-line
            pattern: /^[^\s]+(\s+[^\s]+)*$/,
            passfail: false
        }
    ];

  const [passChecks, setPassChecks] = useState(passChecksFields);
  const [passwordVals, setPasswordVals] = useState(passFields);
  const [passwordErrors, setPasswordErrors] = useState({});
  const [showPass, setShowPass] = useState(false);
  const passIcon = showPass === true ? Hide : View;

  const passwordToggle = useCallback(() => {
    setShowPass((showPass) => !showPass);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (Object.prototype.hasOwnProperty.call(passwordErrors, name)) {
      //reset errors
      setPasswordErrors({});
    }

    setPasswordVals({
      ...passwordVals,
      [name]: value,
    });
    
    if (name === 'password') {
      passwordStrength(value);
    }
  };
  
  const passwordStrength = (password) => {
    if( password === '') {
        setPasswordErrors((prevState) => ({
            ...prevState,
            password: translate('no-password'),
        }));
    }

    passChecks.forEach((check, index) => {
      let pattern = check.pattern;
      let regexCheck = pattern.test(password);
      if (regexCheck === true) {
        let newChecks = [...passChecks];
        newChecks[index].passfail = true;
        
        setPassChecks(newChecks);
      } else {
        let newChecks = [...passChecks];
        newChecks[index].passfail = false;
        
        setPassChecks(newChecks);
      }
    });
  };
  
  const checkPasswordsMatch = () => {
    if (passwordVals.repeatPassword !== passwordVals.password) {
        setPasswordErrors((prevState) => ({
          ...prevState,
          repeatPassword: translate('password-mismatch'),
        }));
    } else {
      setPasswordErrors(
        Object.entries(passwordErrors).filter(
          ([key]) => key !== 'repeatPassword',
        ),
      );
    }
  };

  useEffect(() => {
    //Check if all pass conditions are met
    if (
      Object.keys(passChecks).every(function (k) {
        return passChecks[k].passfail === true;
      })
    ) {
      //All checks passed so set the password
      setFormValues((prevState) => ({
        ...prevState,
        password: passwordVals.password,
      }));

      //Clear password errors
      setPasswordErrors(
        Object.entries(passwordErrors).filter(([key]) => key !== 'password'),
      );
    } else {
      setPasswordErrors((prevState) => ({
        ...prevState,
        password: translate('password-fail')
      }));
    }

    if (passwordVals.password === '') {
      passwordStrength('');
    }

    if (passwordVals.repeatPassword === '') {
      setFormErrors((prevState) => ({
        ...prevState,
        repeatPassword: translate('confirm-password')
      }));
    }

    if (passwordVals.repeatPassword !== '') {
      checkPasswordsMatch();
      setFormValues((prevState) => ({
        ...prevState,
        repeatPassword: translate('repeat-password'),
      }));
    }
  }, [passwordVals]);

  return (
      <Fragment>
          <div
              className={`input-row input-row--password ${
              passwordErrors.password ? 'input-row--error' : ''
              }`}
          >
              <HtmlInput 
                  type={showPass === true ? 'text' : 'password'}
                  id='password'
                  name="password"
                  legend={translate('create-password')}
                  value={passwordVals.password}
                  changeCallback={handleChange}
                  mouseDownCallback={checkPasswordsMatch}
                  blurCallback={checkPasswordsMatch}
                  hasErrors={'password' in passwordErrors}
                  detectCapsLock={true}
              />
              <span className="visibility" onClick={passwordToggle}>
              <img src={passIcon} alt="Toggle Password View" />
              </span>
              <div className="password-checks">
                  {passChecks.map((check, index) => {
                      return <p key={index} className={`password-check ${check.passfail === true ? 'password-check--success' : 'password-check--fail'}`}>{check.title}</p>
                  })}
              </div>
              {passwordErrors.password && (
                  <p className="input-row__error">{passwordErrors.password}</p>
              )}
          </div>
          <div
              className={`input-row input-row--password ${
              passwordErrors.repeatPassword ? 'input-row--error' : ''
              }
              ${passwordErrors.password ? 'input-row--disabled' : ''}
              `}
          >
              <HtmlInput
                  type={showPass === true ? 'text' : 'password'}
                  id='repeatPassword'
                  name="repeatPassword"
                  legend={translate('repeat-password')}
                  value={passwordVals.repeatPassword}
                  changeCallback={handleChange}
                  hasErrors={'repeatPassword' in passwordErrors}
                  detectCapsLock={true}
              />
              <span className="visibility" onClick={passwordToggle}>
              <img src={passIcon} alt={translate('toggle-password')} title={translate('toggle-password')} />
              </span>
              {passwordErrors.repeatPassword && (
              <p className="input-row__error">{passwordErrors.repeatPassword}</p>
              )}
          </div>
      </Fragment>
  )
}

export default PasswordComponent;
